var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.935 18.731h10.296c.715 0 1.294-.588 1.294-1.314v-6.57H3.641v6.57c0 .726.58 1.314 1.294 1.314Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB519",
    d: "M3.641 10.847h12.885v.962H3.641z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.997 7.77h-3.98c-.74 0-1.34.588-1.34 1.313v1.194c0 .315.26.57.581.57h13.839c.32 0 .58-.255.58-.57V9.083c0-.725-.6-1.313-1.34-1.313h-8.34Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.957 7.77H7.59c-1.809-.25-4.023-1.829-3.484-3.496C4.596 2.758 6.067 1.991 7.572 2c2.123.011 2.673 4.225 2.673 4.225h.057S10.852 2.01 12.976 2c1.503-.009 2.975.758 3.465 2.275.539 1.667-1.675 3.246-3.484 3.494Zm1.58-4.239s-.066 2.074-3.01 3.622c0 0 .557-2.662 3.01-3.622Zm-8.502 0c2.452.96 3.008 3.622 3.008 3.622C6.1 5.605 6.035 3.531 6.035 3.531Z",
    fill: "url(#c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3.641,
    y1: 11.372,
    x2: 10.415,
    y2: 23.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2.678,
    y1: 7.975,
    x2: 3.806,
    y2: 13.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.898,
    y1: 2,
    x2: 7.548,
    y2: 12.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A8189"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftColorIcon);
export default __webpack_public_path__ + "static/media/gift-color-icon.def635d50e82554fe090841c5f23734e.svg";
export { ForwardRef as ReactComponent };